import { useFeatures } from 'flagged';
var useFeatureFlags = function () {
    return useFeatures();
};
export default useFeatureFlags;
//# sourceMappingURL=use-feature-flags.js.map